import Slider from "../components/Slider"
import { FiArrowDownRight } from "react-icons/fi"
import useGlobalContext from "../context/GlobalContext"
import { motion, useIsPresent } from "framer-motion"
import { Link } from "react-router-dom"

const Home = () => {
  const isPresent = useIsPresent()
  const { changeCursor } = useGlobalContext()

  return (
    <>
      <motion.div
        initial={{ scaleY: 2 }}
        animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut" } }}
        exit={{ scaleY: 2, transition: { duration: 0.5, ease: "circIn" } }}
        style={{ originY: isPresent ? 0 : 1 }}
        className="privacy-screen"
      />
      <motion.section className="home">
        <Slider />
        <Link
          to="/work/all"
          onMouseEnter={() => changeCursor("hovered")}
          onMouseLeave={() => changeCursor("")}
          className="btn btn-cta uppercase par-md"
        >
          See all works{" "}
          <span className="btn-cta-icon">
            <FiArrowDownRight />
          </span>{" "}
        </Link>
      </motion.section>
    </>
  )
}

export default Home
